export const ExamPopUp = ({ cancelbtn, heading }) => {
    return (
        <>
            <div className="row">
                <di className="col-12">
                    <div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090", }}>
                        <div className="modal-dialog  " role="document" >
                            <div className="modal-content p-3">
                                <div className="modal-header pt-0">

                                    <h5 className="card-title fw-bold green pt-2" style={{ paddingLeft: '10px' }} id="exampleModalLongTitle">{heading}</h5>
                                    <button onClick={() => cancelbtn()} type="button" className="close" style={{ marginLeft: "auto" }}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body examination mx-0" >

                                    <div className="row">

                                        <div className="row p-2 m-0 " >

                                            <div class="mb-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">Full Name:</label>
                                                <input type="text" class="form-control" />
                                            </div>

                                            <div class="my-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">Age:</label>
                                                <input type="text" class="form-control" />
                                            </div>
                                            <div class="my-2 col-12 pb-3">
                                                <label for="exampleFormControlInput1" class="form-label ">Contact Number:</label>
                                                <input type="text" class="form-control" />
                                            </div>

                                            <div class="my-2 col-12 col-lg-3">
                                                <input type="checkbox" id="student" name="status" value="Student" />
                                                <label for="exampleFormControlInput1" class="form-label ps-2">Student</label>
                                            </div>
                                            <div class="my-2 col-12 col-lg-4">
                                                <input type="checkbox" id="Employed" name="status" value="Employed" />
                                                <label for="exampleFormControlInput1" class="form-label ps-2">Employed</label>
                                            </div>
                                            <div class="my-2 col-12 col-lg-5">
                                                <input type="checkbox" id="Self-Employed" name="status" value="Self-Employed" />
                                                <label for="exampleFormControlInput1" class="form-label ps-2">Self-Employed</label>
                                            </div>
                                            <div class="my-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">If Employed, Name of the Organization:</label>
                                                <input type="text" class="form-control" />
                                            </div>
                                            <div class="my-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">Why do you want to take this examination?</label>
                                                <textarea type="text" class="form-control" />
                                            </div>
                                            <div class="my-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">Paid Exam Fees</label>
                                                <input type="text" class="form-control" />
                                            </div>
                                            <div class="my-2 col-12 ">
                                                <label for="exampleFormControlInput1" class="form-label ">Upload Receipt</label>
                                                <input type="upload" class="form-control" />
                                            </div>
                                            <div class="my-3 col-12 ">
                                                <input type="checkbox" id="Self-Employed" name="status" value="Self-Employed" />
                                                <label for="exampleFormControlInput1" class="form-label ps-2">Terms and Condition</label>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12">
                                                <button
                                                    type='button'
                                                    onClick={cancelbtn}
                                                    className="w-80 btn addbtn btn-success  m-2 px-4" data-ktwizard-type="action-next">
                                                    <i class="fa-solid fa-floppy-disk pe-1"></i> Submit
                                                </button>
                                                <button
                                                    type="button"
                                                    onClick={cancelbtn}
                                                    className="w-80  btn addbtn btn-danger  m-2 px-4" data-ktwizard-type="action-next">
                                                    <i class="fa-solid fa-xmark pe-1"></i> Cancel

                                                </button>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </di>
            </div>
        </>
    )
}